/* eslint-disable */
<template lang='pug'>
page-template(title='Gift Certificates')
  v-card(style='max-width:400px;margin-left:auto;margin-right:auto; padding:15px;')
    h4 Redeem Canvas Gift Certificates
    //- {{ searchCode }} {{ redemptionNotes }} {{ checkNumber }}
    v-form(@submit.prevent='getCertificates')
      v-text-field(label='Enter Code' v-model='searchCode' clearable @input='error = ""')
      v-btn(type='submit' :disabled='!searchCode || searchCode.length < 3' @click='getCertificates' outlined :loading='loading').primary--text Search
      div(style='color:red;font-weight:700; margin-top:10px;') {{ error }}
    div(v-if='result && result.length > 0')
      div(v-for='c in result' style='margin-top:20px; border:1px solid grey; padding:10px;')
        //- div {{ c }}
        div <strong>{{ c.name }}</strong>
        div {{ c.value }}
        div(v-if='c.valid' style='color: green; font-weight:600') {{ c.expiration_string }}
        div(v-else style='color: red; font-weight:600') {{ c.expiration_string }}
        div {{ c.details }}
        div <em>{{ c.notes_for_employee }}</em>
        //- div RED {{ c.redeemed_on }} RED
        //- div {{ c }}
        v-text-field(v-if='c.valid' v-model='redemptionNotes[c.id]' label='Redemption Notes' type='text')
        v-text-field(v-if='c.valid' v-model='checkNumber[c.id]' label='Check Number' type='number')
        v-text-field(v-if='c.valid' v-model='spend[c.id]' label='spend' type='number')
        v-btn(:disabled='!c.valid' @click='redeemCoupon(c.id)' outlined) Redeem Coupon
  </template>

<script lang='js'>
import dayjs from 'dayjs'
import axios from 'axios'

export default {
  name: 'GiftCertificates',
  data () {
    return {
      searchCode: '',
      loading: false,
      result: null,
      error: '',
      redemptionNotes: {},
      checkNumber: {},
      spend: {},
    }
  },
  computed: {
  },
  methods: {
    async redeemCoupon (id) {
      try {
        this.loading = true
        // console.log('redeeming coupon: ', id, this.redemptionNotes[id])
        // console.log('store here is: ', this.$store)
        const payload = {
          id,
          location_redeemed: this.$store.state.location.data.id,
          redeemed_by_employee_id: this.$store.state.user.auth.id,
          redeemed_on: dayjs().toISOString(),
          spend: this.spend[id],
          check_number: this.checkNumber[id],
          redemption_notes: this.redemptionNotes[id],
        }
        await axios.post(`https://graph.hartalliance.com/api/rest/updateCouponById/Xcy89chJdG436frNp65HSPRj7q4DMLCJ/${id}`, payload)
        this.result = null
        await this.getCertificates()
        this.loading = false
        // console.log('payload is: ', payload)
      } catch (e) {
        console.log('Error', e)
        this.loading = false
      }
    },
    async getCertificates () {
      try {
        this.loading = true
        const result = await axios.get(`https://graph.hartalliance.com/api/rest/getCouponByContactId/Xcy89chJdG436frNp65HSPRj7q4DMLCJ/${this.searchCode}`)
        // console.log('R: ', result)
        if (!result.data || !result.data.coupon || result.data.coupon.length === 0) {
          this.error = `Cannot Find Any Coupons For VIP User ${this.searchCode}`
          this.result = []
          this.loading = false
          return
        }
        this.result = result.data.coupon.map((coupon) => {
          let es = ''
          let valid = false
          let expiration = dayjs(0)
          if (!coupon.expiration) {
            es = 'No Expiration'; valid = true
          } else {
            expiration = dayjs(coupon.expiration)
          }
          if (expiration > dayjs()) {
            es = `Expires ${coupon.expiration}`
            valid = true
          } else {
            es = `Expired ${coupon.expiration}`
            valid = false
          }
          if (coupon.redeemed_on) {
            valid = false
            es = `Certificate Redeemed ${dayjs(coupon.redeemed_on).format('M/D/YY h:mma')}`
          }
          // eslint-disable-next-line no-param-reassign
          coupon.expiration_string = es
          // eslint-disable-next-line no-param-reassign
          coupon.valid = valid
          return coupon
        })
        this.loading = false
      } catch (e) {
        this.loading = false
        this.error = 'Cannot Find'
      }
    },
  },
}
</script>


<style lang='scss'>
</style>
